import type { RouteRecordRaw } from "vue-router";

export const medicalRoutes: RouteRecordRaw = {
    path: '/medical',
    children: [
        {
            path: 'patient-flow',
            name: 'PatientFlow',
            component: () => import('@/modules/medical/patient-flow/PatientFlow.vue'),
            meta: { defaultLayout: false, layoutMode: 'fullscreen' }
        },
        {
            name: 'Drug Logs',
            path: 'drug-log',
            component: () => import('./drug-log/DrugLog.vue')
        },
        {
            name: 'Drug Logs - Drugs by Patient',
            path: 'drugs-by-patient/:date',
            component: () => import('./drug-log/DrugsPatient.vue')
        },
        {
            name: 'Drug Logs - Bottle Logs',
            path: 'bottle-logs/:date',
            component: () => import('./drug-log/BottleLogs.vue')
        },
        {
            name: 'Drug Logs - Bottle Logs Detail',
            path: 'bottle-logs/:date/:drugId',
            component: () => import('./drug-log/BottleLogsDetails.vue')
        },
        {
            name: 'AM Tasks',
            path: 'am-tasks',
            meta: { layoutMode: 'fullscreen', defaultLayout: false },
            component: () => import('./am-tasks/AmTasks.vue')
        },
        {
            name: 'Patient Flow',
            path: 'patient-flow',
            meta: { layoutMode: 'fullscreen', defaultLayout: false },
            component: () => import('./patient-flow/PatientFlow.vue'),
            children: [
                {
                    name: 'Patient Flow | Divvy',
                    path: 'divvy',
                    component: () => import('./patient-flow/divvy/DivvyList.vue')
                },
                {
                    name: 'Patient Flow | Divvy Assign',
                    path: 'divvy/:date/:categoryId',
                    component: () => import('./patient-flow/divvy/DivvyAssignAnimals.vue')
                },
                {
                    name: 'Patient Flow | Exam and Premed',
                    path: 'exam-premed',
                    component: () => import('./patient-flow/partials/ExamPremed.vue')
                },
                {
                    name: 'Patient Flow | Drug Draw',
                    path: 'drug-draw',
                    component: () => import('./patient-flow/partials/DrugDraw.vue')
                },
                {
                    name: 'Patient Flow | Surgery',
                    path: 'surgery',
                    component: () => import('./patient-flow/partials/Surgery.vue')
                },
                {
                    name: 'Patient Flow | Rx',
                    path: 'rx',
                    component: () => import('./patient-flow/partials/Rx.vue')
                },
                {
                    name: 'Patient Flow | HRW',
                    path: 'hrw',
                    component: () => import('./patient-flow/partials/Hrw.vue')
                },
                {
                    name: 'Patient Flow | Declined',
                    path: 'declined',
                    component: () => import('./patient-flow/partials/Declined.vue')
                }
            ]
        }
    ]
}